var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUnlocked = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg",
  className: "_dm-svg",
  focusable: "false",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9 6h4a2 2 0 012 2v6a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2V4a4 4 0 014-4h2a4 4 0 014 4H9.732A2 2 0 006 5v1h3zM8 8a1 1 0 00-1 1v4a1 1 0 002 0V9a1 1 0 00-1-1z",
  fillRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgUnlocked);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Unlocked.2519fe6f57347a50c5f9f3ea72b1c37d.svg";